import { Address, APIResponse, ConfigurableAppQueryArgs, useAppQuery } from '@alluradirect/react';

const propertyInformation = '/RESTAUTH/property/information/';

interface Args {
  pid: number;
}

export interface ImageData {
  CAPTION: string;
  FULL: string;
  THUMB: string;
  ID: number;
  SORT_ORDER: number;
}

interface ReturnData {
  ADDRESS: Address;
  ADVANCED_BOOKING_DAYS: number;
  AVERAGE_REVIEW_SCORE: number;
  DV_LOGO_FILEPATH: string;
  HOST_FIRST_NAME: string;
  ID: number;
  IS_PET_FRIENDLY: boolean;
  MAX_CAPACITY: number;
  MIN_AGE_TO_BOOK: number;
  NUM_BATHS: number;
  NUM_BEDS: number;
  NUM_REVIEWS: number;
  PHOTOS: ImageData[];
  SIZE_CATEGORY: string;
  SQUARE_FEET: number;
  STYLE: string;
  THUMBNAIL_URL: string;
  TITLE: string;
}

export const usePropertyInformationQuery = ({ pid, ...rest }: Args & ConfigurableAppQueryArgs) => {
  return useAppQuery<APIResponse<ReturnData>>({
    endpoint: `${propertyInformation}?id=${pid}`,
    ...rest,
  });
};
